import { z } from 'zod'
import type { FinTechStack } from './types'

export const FinTechStackSchema = z.enum(['SAP', 'Oracle', 'Workday'])
export const AppVariantSchema = z.literal('fin')

// Bidirectional guard — type-errors if schema and FinTechStack diverge in either direction.
// Not exported (would fail knip). void expression satisfies noUnusedLocals.
const _schemaMatchesType: [z.infer<typeof FinTechStackSchema>] extends [FinTechStack]
  ? [FinTechStack] extends [z.infer<typeof FinTechStackSchema>] ? true : never : never = true
void _schemaMatchesType
